import { render } from "./Login.vue?vue&type=template&id=aa529668"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=aa529668&lang=scss"
script.render = render

export default script